<mat-table
  (matSortChange)="sortChange($event)"
  matSort
  [dataSource]="dataSource.data"
  class="integration-imports-table">

  <ng-container matColumnDef="operation">
    <mat-header-cell *matHeaderCellDef mat-sort-header="OPERATION" class="operation-header">
      {{ 'INTEGRATIONS.HEADERS.OPERATION' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="operation-wrapper">
      <span>{{'INTEGRATIONS.' + element.operation | translate}}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="startDate">
    <mat-header-cell *matHeaderCellDef mat-sort-header="START_DATE" class="date-header">
      {{ 'INTEGRATIONS.HEADERS.START_DATE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="date-wrapper">{{ formatDate(element.startDate) }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="finishDate">
    <mat-header-cell *matHeaderCellDef mat-sort-header="FINISH_DATE" class="date-header">
      {{ 'INTEGRATIONS.HEADERS.FINISH_DATE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="date-wrapper">{{ formatDate(element.finishDate) }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef mat-sort-header="STATUS">
      {{ 'INTEGRATIONS.HEADERS.STATUS' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="status-wrapper">
      <span>{{'INTEGRATIONS.STATUS_TYPES.' + element.status | translate}}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="contactsCreated">
    <mat-header-cell *matHeaderCellDef mat-sort-header="CONTACTS_CREATED">
      {{ 'INTEGRATIONS.HEADERS.CONTACTS_CREATED' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span>{{ element.contactsCreated }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="contactsUpdated">
    <mat-header-cell *matHeaderCellDef mat-sort-header="CONTACTS_UPDATED">
      {{ 'INTEGRATIONS.HEADERS.CONTACTS_UPDATED' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span>{{ element.contactsUpdated }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="contactsRejected">
    <mat-header-cell *matHeaderCellDef mat-sort-header="CONTACTS_REJECTED">
      {{ 'INTEGRATIONS.HEADERS.CONTACTS_REJECTED' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="contacts-rejected-cell-wrapper">
      <span
        (click)="rejectedClicked.emit(element.id)"
        [routerLink]="['/integrations/imports', element.id]">{{element.contactsRejected}}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="integrationType">
    <mat-header-cell *matHeaderCellDef mat-sort-header="INTEGRATION_TYPE">
      {{ 'INTEGRATIONS.HEADERS.INTEGRATION_TYPE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="integration-type-wrapper">
      <span>{{'INTEGRATIONS.' + element.integrationType + '.LOG_TYPE' | translate }}</span>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>
